export const TRANSLATIONS = {
  COMMON: {
    VALIDATION: {
      REQUIRED_FIELD: '{0}を入力してください。',
      INVALID_EMAIL: '有効なメールアドレスを入力してください。',
      FULL_KATAKANA: '全角カタカナで入力してください。',
      HALF_PHONE: 'ハイフンを含む半角数字で入力してください。',
    },
    ACTION: {
      CANCEL: 'キャンセル',
      SETTINGS: '設定',
      NEXT: '次へ',
      BACK: '戻る',
      CLEAR: 'クリア',
      TODAY: '今日',
      APPLY: '適用',
      EDIT: '編集する',
      SAVE: '保存する',
      CLOSE: '閉じる',
      RETRY: '再試行',
    },
    STATUS: {
      NO_DATA: 'データがありません',
      NO_IMAGE_TITLE: 'NO IMAGE',
      NO_IMAGE_HINT: '画像がありません',
      TABLE_RANGE_TEXT: '{0}〜{1} 件を表示（全 {2} 件）',
      LOADING: '読み込み中...',
    },
    TABLE: {
      SELECT_ROW: '{0}を選択',
    },
    TIME_PICKER: {
      TITLE: '時刻選択',
      HOUR: '{0}時',
      MINUTE: '{0}分',
    },
    TOAST: {
      TITLE: 'トースト',
      SYNC_RUNNING: 'データを同期しています...',
      SYNC_SUCCESS: 'データの同期が完了しました。',
    },
    FIELD: {
      BASIC_INFO: '基本情報',
      NAME: '氏名',
      NAME_KANA: '氏名（カナ）',
      EMAIL: 'メールアドレス',
      PHONE: '電話番号',
      COMPANY_NAME: '法人名',
      OFFICE_NAME: '事業所名',
      SERVICE_TYPE: 'サービス種別',
      OTHER_DETAIL: 'その他の内容',
      CAREKARTE_SCOPE: 'CAREKARTE使用範囲',
      ROLE: 'ロール',
      STATUS: 'ステータス',
      PROFILE: 'プロフィール',
    },
    LIST: {
      SEARCH: '検索する',
      DISPLAY_COUNT: '表示件数',
      COLUMN_STATUS: 'ステータス',
      COLUMN_DETAIL: '詳細',
      DETAIL_ARIA: '{0}の詳細を表示',
    },
    ASYNC: {
      LOADING: '{0}を読み込んでいます…',
      LOAD_ERROR_TITLE: '読み込みに失敗しました',
      LOAD_ERROR_MESSAGE: 'データの読み込みに失敗しました。再読み込みしてください。',
      RETRY_NOTICE: 'しばらくしてから再度お試しください。',
    },
    DISCARD_DIALOG: {
      TITLE: '変更を破棄しますか？',
      MESSAGE: '保存されていない変更は失われます。\n変更を破棄しますか？',
      STAY: '編集に戻る',
      DISCARD: '破棄する',
    },
    CONFIRM_DIALOG: {
      INSTRUCTION: '変更内容を確認のうえ、必要に応じて管理用メモを入力してください。',
      MEMO_LABEL: '管理用メモ',
      MEMO_HINT: 'この内容はユーザーには表示されません。操作履歴に記録されます。',
    },
    CHOICE: {
      FIRST_TIME: '初参加',
      REPEAT_VISIT: '2回以上',
      ACCOMMODATION_YES: '希望あり',
      ACCOMMODATION_NO: '希望なし',
      PRE_NIGHT: '前泊',
      POST_NIGHT: '後泊',
      NON_SMOKING: '禁煙',
      SMOKING: '喫煙',
      LUNCH_NEEDED: '要',
      LUNCH_NOT_NEEDED: '不要',
      DINNER_POSSIBLE: '可能',
      DINNER_IMPOSSIBLE: '不可',
    },
    FORM: {
      COMMENTS_PLACEHOLDER: 'ご質問・ご要望・特別な配慮が必要な場合など、ご自由にご記入ください',
    },
    TIME: {
      LABEL: '時刻',
      HOUR: '時',
      MINUTE: '分',
    },
  },
  CALENDAR: {
    DAY: {
      SUN: '日',
      MON: '月',
      TUE: '火',
      WED: '水',
      THU: '木',
      FRI: '金',
      SAT: '土',
    },
    STATUS: {
      FULL: '満席',
      REMAINING: '残',
    },
    LABEL: {
      RESERV_DATE: '予約日',
    },
    LEGEND: {
      ARIA_LABEL: 'カレンダーの凡例',
      FULL: '選択中',
      AVAILABLE: '空席・選択可能',
      UNAVAILABLE: '満席・選択不可',
    },
    NAV: {
      PREVIOUS_MONTH: '前月',
      NEXT_MONTH: '次月',
    },
  },
  NAV: {
    MENU: {
      HOME: 'ホーム',
      DASHBOARD: 'ダッシュボード',
      SCAN: 'スキャン',
      MY_PROFILE: 'マイプロフィール',
      RESERVATION_HISTORY: '予約履歴',
      PROGRAM: 'プログラムについて',
      ABOUT_USUPP: 'ウサップとは',
      NEWS: 'お知らせ',
      RESERVATION: '予約する',
      RESERVATION_CONFIRM: '予約確認',
      CONTACT: 'お問い合わせ',
      LOGOUT: 'ログアウト',
      CALENDAR: 'カレンダー',
      SECTION_SYSTEM: 'システム設定',
      SECTION_OPERATION: '運用設定',
      BOOKING_MGMT: '予約管理',
      CREATE_SCHEDULE: '予定作成',
      LOCATION_SETTINGS: '場所設定',
      INQUIRY_MGMT: 'お問合せ管理',
      NEWS_MGMT: 'お知らせ管理',
      BOOKING_RULES: '予約ルール設定',
      CLIENT_MANAGER: 'プロフィール管理',
      MEMBER_MGMT: 'メンバー管理',
    },
    MAIN_ARIA: 'メインナビゲーション',
    MOBILE_ARIA: 'モバイルナビゲーション',
    DRAWER_ARIA: 'ナビゲーションメニュー',
    OPEN_ARIA: 'メニューを開く',
    CLOSE_ARIA: 'メニューを閉じる',
    HOME_LINK_ARIA: 'U-SUPP-U ホーム',
  },
  ADMIN: {
    DASHBOARD: {
      SUBTITLE: '{0}まで集計数字',
      STATS: {
        TODAY_RESERVATIONS: '本日の予約',
        PENDING_RESERVATIONS: '対応待予約',
        PENDING_INQUIRIES: '対応待お問合',
        CANCELLED_RESERVATIONS: 'キャンセル予約',
        NEXT_MONTH_RESERVATIONS: '来月の予約',
      },
      LOCATIONS: {
        TITLE: '本日訪問予定詳細',
        INITIAL_VISIT: '初参加',
        REPEAT_VISIT: 'リピーター',
        EMPTY_TITLE: '訪問予定はありません',
        EMPTY_DESCRIPTION: '本日訪問予定の場所はありません。',
      },
      CHART: {
        TITLE: '予約合計数',
        RANGE_1_DAY: '過去1日',
        RANGE_7_DAYS: '過去7日間',
        RANGE_30_DAYS: '過去1ヶ月間',
        RANGE_90_DAYS: '過去3ヶ月間',
        ARIA_LABEL: '予約合計数 {0}〜{1}、{2}の合計',
        EMPTY_TITLE: '予約なし',
        EMPTY_DESCRIPTION: '選択した期間の予約はありません。',
      },
    },
    SIDEBAR: {
      ROLE_ADMIN: '管理者',
      ROLE_STAFF: '閲覧者',
    },
    BOOKING_RULES: {
      BACK_TO_HOME: 'ホームに戻る',
      UPDATE: 'ルール更新',
      BOOKING_DEADLINE: '予約受付締切',
      CANCELLATION_DEADLINE: 'キャンセル締切',
      CANCELLATION_DAY_PREFIX: '予約日の',
      DAYS_BEFORE: '日前の',
      DAYS_BEFORE_SHORT: '日前',
      UNTIL: 'まで',
      BOOKING_DEADLINE_DAYS_PLACEHOLDER: '例：3',
      CANCELLATION_DEADLINE_DAYS_PLACEHOLDER: '例：5',
      BOOKING_DEADLINE_DAYS_ARIA: '予約受付締切の日数',
      BOOKING_DEADLINE_TIME_ARIA: '予約受付締切の時刻',
      CANCELLATION_DEADLINE_DAYS_ARIA: 'キャンセル締切の日数',
      CANCELLATION_DEADLINE_TIME_ARIA: 'キャンセル締切の時刻',
      BOOKING_DEADLINE_HELP:
        '指定した日時を過ぎると、その日の予約を受け付けなくなります。例「3日前の18:00まで」に設定した場合、8月10日の予約は8月7日の18:00以降受付できません。',
      CANCELLATION_DEADLINE_HELP:
        '指定した日時を過ぎるとキャンセルできなくなります。例「5日前の23:59まで」に設定した場合、8月10日の予約は8月5日の23:59以降キャンセルできません。',
      NOT_CONFIGURED: '未設定',
      SAVE_SUCCESS: '予約ルールを保存しました。',
      SAVE_ERROR: '予約ルールの保存に失敗しました。',
      VALIDATION_DAYS_REQUIRED: '日数を入力してください。',
      VALIDATION_DAYS_RANGE: '1〜30の範囲で日数を入力してください。',
      VALIDATION_TIME_REQUIRED: '時刻を入力してください。',
    },
    BOOKING: {
      TABLE_ARIA: '予約一覧',
      STATUS: {
        REGISTERED: '受付中',
        SALES_CONFIRMING: '営業確認中',
        PARTICIPATION_OK: '参加OK',
        GUIDING: '案内中',
        GUIDED: '案内済み',
        CONTRACTING: '契約中',
        CONTRACT_COMPLETED: '契約完了',
        DONE: '完了',
        USER_CANCELLED: '本人キャンセル',
        ADMIN_CANCELLED: '管理者キャンセル',
      },
      DETAIL: {
        TITLE: '予約詳細',
        HEADER_TITLE: '{0}の詳細',
        NOT_FOUND: '予約が見つかりません',
        UNASSIGNED: '未割当',
        REGISTRATION_DATE: '登録日',
        ATTENDANCE_INFO: '参加情報',
        PAST_PARTICIPATION: '過去参加状況',
        REPEATER: 'リピーター',
        ACCOMMODATION_REQUEST: '宿泊先のCCJ手配希望',
        ACCOMMODATION_REQUEST_VIEW: '宿泊先の手配希望',
        DESIRED_ARRANGEMENT: '手配希望',
        TRANSPORTATION: '移動手段',
        LODGING_MEALS: '宿泊・食事',
        SMOKING_PREF: '禁煙／喫煙',
        LUNCH_PREF: '昼食（お弁当）',
        DINNER_PREF: '夕食会参加可否',
        DINNER_DATES: '夕食会参加可能な日程',
        NOTES: '連絡事項',
        NOTES_LABEL: '連絡事項（任意）',
        HISTORY: '操作履歴',
        DAYS_COUNT: '{0}日間',
        DAYS_SELECTED_COUNT: '{0}日間選択中',
        SELECT_PLACEHOLDER: '選択してください',
        ATTENDANCE_POSSIBLE_DATES: '参加可能日',
        STATUS_LABEL: 'ステータス',
        ASSIGNEE_LABEL: '担当者',
        APPLIED_DATE: '申込日',
        LOCATION_LABEL: '場所',
        DATE_LABEL: '予約日',
        APPLICANT_LABEL: '予約者',
        LOG_REMARKS: '備考',
        SAVE_SUCCESS: '予約情報を更新しました。',
        SAVE_ERROR: '予約情報の更新に失敗しました。画面を再読み込みし、再度お試しください。',
        STALE_ERROR:
          'この予約は他のユーザーによって更新されました。画面を再読み込みして、最新の内容を確認してください。',
        RESCHEDULE_DEADLINE_ERROR: 'キャンセル締切を過ぎているため、予約日を変更できません。',
        DUPLICATE_ERROR: '予約者は選択した日程にすでに予約があります。日程を再選択してください。',
        SLOT_UNAVAILABLE_ERROR:
          '満席または受付枠のない日程が含まれています。日程を再選択してください。',
      },
      LOG: {
        STATUS_CHANGED: '予約のステータスを「{0}」に変更しました。',
        ASSIGNEE_CHANGED: '担当者を「{0}」に変更しました。',
        ASSIGNEE_CLEARED: '担当者を{0}に変更しました。',
        ASSIGNEE_NONE: '未設定',
        RESCHEDULED: '予約日を「{0}」に変更しました。',
        UPDATED: '予約情報を更新しました。',
        MEMO_ADDED: '備考を追加しました。',
      },
      CREATE_FORM: {
        CALENDAR_INVALID: '選択した日程に予約できない日が含まれています。',
        DATE_PLACEHOLDER: '予約日を選択',
      },
      USER_INFO_DIALOG: {
        TITLE: '予約者情報',
        SERVICE_INFO: 'サービス情報',
      },
      CONFIRM_DIALOG: {
        TITLE: '予約内容の変更確認',
        MEMO_PLACEHOLDER: '例：ユーザーからの依頼により予約日を変更',
      },
      LIST: {
        TITLE: '予約一覧',
        SEARCH_PLACEHOLDER_DESKTOP: '予約IDや予約者で検索出来る',
        DATE_FILTER_LABEL: '日付で絞込',
        DATE_FILTER_PLACEHOLDER: '予約日を選択',
        DATE_FILTER_VALUE: '{0}〜{1} （{2}日間）',
        DATE_FILTER_FROM: '{0}〜',
        SEARCH_ARIA: '予約を検索',
        SCAN_BUTTON: 'QRコードをスキャン',
        DOWNLOAD_BUTTON: 'ダウンロード',
        TOOLTIP_CSV: 'テーブルに表示されているデータをExcel形式でダウンロードします',
        DOWNLOAD_ERROR_MESSAGE:
          'エクセルファイルをダウンロードできませんでした。しばらく時間をおいてから再度お試しください。',
        COL_ID: '予約ID',
        COL_NAME: '予約者',
        COL_LOCATION: '予約場所',
        COL_DATE: '予約日',
        COL_STATUS: '予約状況',
        COL_ASSIGNEE: '担当者',
        COL_APPLIED_AT: '申込日',
        DETAIL_ARIA: '{0}の予約詳細を表示',
      },
      QR_SCAN: {
        TITLE: 'QRコードをスキャン',
        REQUESTING: 'カメラへのアクセスを準備しています...',
        INSTRUCTION: '予約チケットのQRコードにカメラを向けてください',
        PERMISSION_DENIED:
          'カメラへのアクセスが許可されていません。ブラウザの設定を確認してください。',
        NO_CAMERA: 'カメラは他のアプリで使用中です。他のアプリを閉じてから、再度お試しください。',
        MANUAL_ENTRY_LABEL: '予約番号を入力',
        MANUAL_ENTRY_PLACEHOLDER: '予約番号（例: SHIX7bQ9mK）',
        MANUAL_ENTRY_SUBMIT: '確認する',
      },
      CREATE: {
        HEADER_TITLE: '予約作成',
      },
      EDIT: {
        TITLE: '予約情報編集',
        SUBMIT: '変更を保存する',
      },
      VIEW: {
        LOG_TIMELINE: '変更履歴',
        BACK_TO_LIST: '一覧に戻る',
        EDIT_BUTTON: '予約更新',
      },
    },
    LOCATION: {
      TABLE_ARIA: '場所一覧',
      STATUS_ENABLED: '有効',
      STATUS_DISABLED: '無効',
      LIST: {
        SEARCH_PLACEHOLDER_DESKTOP: '表示名称や識別名称で検索出来る',
        SEARCH_ARIA: '場所を検索',
        CREATE_BUTTON: '場所追加',
        BULK_ACTIONS: '一括操作',
        BULK_ENABLE: '有効にする',
        BULK_DISABLE: '無効にする',
        BULK_ERROR_TOAST: '場所のステータスの一括変更に失敗しました。',
        COL_NAME: '表示名称',
        COL_IDENTIFIER: '識別名称',
        COL_SLOT_COUNT: '現在の枠数',
        COL_SLOT_PERIOD: '現在の枠の有効期間',
      },
      CREATE: {
        HEADER_TITLE: '場所作成',
        TITLE: '場所新規作成',
        DISPLAY_NAME_LABEL: '表示名称',
        DISPLAY_NAME_PLACEHOLDER: '例：静岡本社',
        IDENTIFIER_LABEL: '識別名称',
        IDENTIFIER_PLACEHOLDER: '例：SHI',
        IDENTIFIER_HINT: '場所を識別する英字3文字を入力してください。※予約ID生成に使用',
        ADDRESS_LABEL: '住所',
        ADDRESS_PLACEHOLDER: '例：静岡県静岡市葵区呉服町1-1-1',
        THEME_COLOR_LABEL: 'テーマ色',
        THEME_COLOR_PLACEHOLDER: 'テーマ色を選択',
        GOOGLE_MAP_URL_LABEL: 'Google Map',
        GOOGLE_MAP_URL_PLACEHOLDER: '例：https://maps.google.com/...',
        GOOGLE_MAP_URL_HINT: 'Googleマップで場所を検索し、共有リンクを貼り付けてください。',
        TEL_LABEL: '電話番号',
        TEL_PLACEHOLDER: '例：054-255-3343',
        GUIDE_URL_LABEL: '案内書URL',
        GUIDE_URL_PLACEHOLDER: '例：https://works.do/GTWxzdJ',
        GUIDE_URL_HINT: '自動返信内容に使用',
        STATUS_LABEL: 'ステータス',
        STATUS_HINT: '無効にすると、利用者さんに非表示にします',
        IMAGE_TITLE: '場所写真',
        IMAGE_UPLOAD_PROMPT: '画像アップロード',
        IMAGE_UPLOAD_HINT: 'JPEG / PNG / WEBP形式 (任意)',
        IMAGE_REPLACE: '画像を差し替える',
        IMAGE_REMOVE: '画像を削除',
        VALIDATION: {
          DISPLAY_NAME_REQUIRED: '表示名称を入力してください。',
          IDENTIFIER_REQUIRED: '識別名称を入力してください。',
          IDENTIFIER_FORMAT: '識別名称は半角英字3文字で入力してください。',
          IDENTIFIER_TAKEN: 'この識別名称はすでに使用されています。別の識別名称を入力してください。',
          THEME_COLOR_REQUIRED: 'テーマ色を選択してください。',
          INVALID_URL: 'http:// または https:// で始まる有効なURLを入力してください。',
          INVALID_IMAGE_TYPE: 'JPEG、PNG、WebP形式の画像ファイルを選択してください。',
          IMAGE_MAX_SIZE: '画像のファイルサイズは5MB以下にしてください。',
        },
        COLOR_SET_1: 'カラー01',
        COLOR_SET_2: 'カラー02',
        COLOR_SET_3: 'カラー03',
        COLOR_SET_4: 'カラー04',
        COLOR_SET_5: 'カラー05',
        COLOR_SET_6: 'カラー06',
        COLOR_SET_7: 'カラー07',
        COLOR_SET_8: 'カラー08',
        COLOR_SET_9: 'カラー09',
        ERROR_TOAST: '場所の作成に失敗しました。',
      },
      CREATE_SUCCESS: {
        BANNER: '場所が作成できました。',
        BANNER_PARTIAL:
          '場所は作成されましたが、写真を保存できませんでした。編集画面から再設定してください。',
        BACK_TO_LIST: '一覧に戻る',
      },
      DETAIL: {
        HEADER_TITLE: '{0}の詳細',
        BACK: '一覧に戻る',
        UPDATE: '場所更新',
        BASIC_TAB: '場所基本情報',
        SLOTS_TAB: '空き枠管理',
        TABS_ARIA: '場所詳細タブ',
      },
      EDIT: {
        HEADER_TITLE: '場所更新',
        SAVE: '場所更新',
        SUBMIT: '場所更新',
        SUCCESS_TOAST: '場所を更新しました。',
        ERROR_TOAST: '場所の更新に失敗しました。',
      },
      SLOT: {
        PREVIEW_TITLE: 'プレビュー',
        CALENDAR_FOOTNOTE: 'カレンダーには、各日に設定されている枠数が表示されます。',
        ADD: '空き枠追加',
        ADD_SUBMIT: '追加する',
        ADD_TITLE: '空き枠追加',
        EDIT_TITLE: '空き枠編集',
        WARNING_TITLE: '確認',
        WARNING_MESSAGE:
          'この枠には予約済みのユーザーがいます。\n変更を保存すると、該当ユーザーの予約内容に影響する可能性があります。',
        TABLE_TITLE: '枠一覧',
        TABLE_NOTE:
          '当月の登録済み空き枠を表示しています。他の月を確認するには、プレビューカレンダーで月選択ボタンをクリックしてください。',
        PERIOD: '有効期間',
        CAPACITY: '定員数',
        ACTION: '操作',
        EDIT_ARIA: '{0}の空き枠を編集',
        EDIT_LOCKED_ARIA: '{0}の空き枠は編集できません',
        START_DATE: '有効開始日',
        END_DATE: '有効終了日',
        START_DATE_PLACEHOLDER: '例：2026/07/30',
        END_DATE_PLACEHOLDER: '例：2026/08/30',
        NO_END_DATE: '無期限',
        CAPACITY_PLACEHOLDER: '例：30',
        EMPTY: '登録されている空き枠はありません。',
        ERROR: '空き枠を保存できませんでした。',
        VALIDATION: {
          START_DATE_REQUIRED: '有効開始日を入力してください。',
          END_DATE_REQUIRED: '有効終了日を入力してください。',
          END_BEFORE_START: '有効終了日は有効開始日以降の日付を入力してください。',
          CAPACITY_INVALID: '定員数には1以上の数値を入力してください。',
          START_DATE_TOO_SOON: '有効開始日は{0}より後の日付を入力してください。',
          OVERLAP: '指定した期間は、空き枠（{0}～{1}）と重複しています。',
        },
      },
    },
    NEWS: {
      TABLE_ARIA: 'お知らせ一覧',
      STATUS_PUBLISHED: '公開',
      STATUS_UNPUBLISHED: '非公開',
      LIST: {
        SEARCH_PLACEHOLDER_DESKTOP: 'タイトルで検索出来る',
        SEARCH_ARIA: 'お知らせを検索',
        CREATE_BUTTON: 'お知らせ追加',
        BULK_ACTIONS: '一括操作',
        BULK_PUBLISH: '公開にする',
        BULK_UNPUBLISH: '非公開にする',
        BULK_ERROR_TOAST: '公開状態の一括変更に失敗しました。',
        COL_TITLE: 'タイトル',
        COL_AUTHOR: '投稿者',
        COL_REGISTERED_AT: '登録日',
      },
      CREATE: {
        HEADER_TITLE: 'お知らせの新規作成',
        TITLE: 'お知らせの新規作成',
        TITLE_LABEL: 'タイトル',
        TITLE_PLACEHOLDER: '【重要】U-SUPP-U（ウサップ）ご参加前に',
        CONTENT_LABEL: '本文',
        SUCCESS_BANNER: 'お知らせが作成できました。',
        ERROR_TOAST: 'お知らせの作成に失敗しました。',
      },
      DETAIL: {
        HEADER_TITLE: 'お知らせの編集',
        TITLE: 'お知らせ詳細',
        BACK_TO_LIST: '一覧に戻る',
        UPDATE_BUTTON: 'お知らせ更新',
        AUTHOR_LABEL: '投稿者',
        DATE_LABEL: '登録日',
        NOT_FOUND: 'お知らせが見つかりません',
        STATUS_ERROR_TOAST: '公開状態の変更に失敗しました。',
      },
      EDIT: {
        HEADER_TITLE: 'お知らせの編集',
        TITLE: 'お知らせの編集',
        TITLE_LABEL: 'タイトル',
        CONTENT_LABEL: '本文',
        SUCCESS_TOAST: 'お知らせを更新しました。',
        ERROR_TOAST: 'お知らせの更新に失敗しました。',
      },
    },
    INQUIRY: {
      TABLE_ARIA: 'お問合せ一覧',
      STATUS_UNHANDLED: '未対応',
      STATUS_IN_PROGRESS: '対応中',
      STATUS_COMPLETED: '対応済み',
      TYPE_RESERVATION: '予約に関して連絡',
      TYPE_OTHER: 'その他',
      LIST: {
        SEARCH_PLACEHOLDER_DESKTOP: 'キーワードで検索する',
        SEARCH_ARIA: 'お問合せを検索',
        COL_NAME: '氏名',
        COL_RESERVATION_CONTACT: '予約に関して連絡',
        COL_STATUS: 'ステータス',
        COL_EMAIL: 'メールアドレス',
        COL_PHONE: '電話番号',
        COL_RECEIVED_AT: '受付日',
      },
      DETAIL: {
        HEADER_TITLE: 'お問合せ情報',
        NAME: '氏名',
        EMAIL: 'メールアドレス',
        PHONE: '電話番号',
        RECEIVED_AT: '受付日',
        STATUS: 'ステータス',
        INQUIRY_TYPE: 'お問合せ種別',
        RESERVATION_NUMBER: '予約番号',
        CONTENT: 'お問合せ内容',
        HISTORY: '操作履歴',
        LOG_COMMENT: '備考',
        NOT_FOUND: 'お問合せが見つかりません',
      },
      VIEW: {
        BACK_TO_LIST: '一覧に戻る',
        EDIT_BUTTON: 'お問合せ更新',
      },
      LOG: {
        RECEIVED: 'お問合せを受け付けました。',
        STATUS_CHANGED: '{0}がステータスを「{1}」に変更しました。',
        TYPE_CHANGED: '{0}がお問合せ種別を「{1}」に変更しました。',
        BOOKING_NO_ADDED: '{0}が予約番号を追加しました。',
        BOOKING_NO_CHANGED: '{0}が予約番号を変更しました。',
        BOOKING_NO_DELETED: '{0}が予約番号を削除しました。',
      },
      BOOKING_INFO_DIALOG: {
        TITLE: '{0}の情報',
        CREATED_AT: '登録日',
        PARTICIPATION_INFO: '参加情報',
        PAST_PARTICIPATION: '過去参加状況',
        ACCOMMODATION_REQUEST: '宿泊先の手配希望',
      },
      EDIT: {
        HEADER_TITLE: 'お問合せ情報',
        TITLE: 'お問合せ情報編集',
        SUBMIT: '保存する',
        CANCEL: 'キャンセル',
        SUCCESS_TOAST: 'お問合せ情報を更新しました。',
        ERROR_TOAST: 'お問合せ情報の更新に失敗しました。',
        RESERVATION_NUMBER_PLACEHOLDER: '例：FSZ123abc7',
        BOOKING_NO_MATCH: '該当する予約が見つかりません。',
        BOOKING_NOT_SELECTED: '候補から予約を選択してください。',
        CONFIRM_DIALOG: {
          TITLE: 'お問合せの変更確認',
          MEMO_PLACEHOLDER: '例：ユーザーからの依頼により予約日を変更',
        },
      },
    },
    CLIENT: {
      TITLE: 'プロフィール管理',
      TABLE_ARIA: 'クライアント一覧',
      LIST: {
        SEARCH_PLACEHOLDER_DESKTOP: 'キーワードで検索する',
        SEARCH_ARIA: 'クライアントを検索',
        COL_NAME: '氏名',
        COL_EMAIL: 'メールアドレス',
        COL_PHONE: '電話番号',
        COL_COMPANY: '法人名',
        COL_OFFICE: '事業所名',
      },
      DETAIL: {
        HEADER_TITLE: '{0}の詳細',
        FALLBACK_TITLE: 'プロフィール詳細',
        BACK: '一覧に戻る',
        VIEW_ARIA: 'クライアント詳細',
        NOT_FOUND: 'プロフィールが見つかりません。',
        EMAIL: 'メール',
      },
    },
    MEMBER: {
      TITLE: 'メンバー管理',
      TABLE_ARIA: 'メンバー一覧',
      ROLE: {
        ADMIN: '管理者',
        STAFF: '閲覧者',
      },
      LIST: {
        SEARCH_PLACEHOLDER_DESKTOP: '表示名で検索する',
        SEARCH_ARIA: 'メンバーを表示名で検索',
        COL_NAME: '表示名',
        COL_VIA: '招待経由',
        COL_ROLE: 'ロール',
      },
      ACTION: {
        MANAGE_INVITATIONS: '招待中管理',
        INVITE: 'メンバー招待',
      },
      INVITE: {
        TITLE: 'メンバー招待',
        DESCRIPTION:
          'Carkarte Passアカウントに登録済みのメールアドレスまたは電話番号を入力してください。USUPPUを管理者または閲覧者として利用するための招待リンクが送信されます。',
        CONTACT_METHOD: '招待経由',
        CONTACT_EMAIL: 'メール',
        CONTACT_PHONE: '電話番号',
        EMAIL_PLACEHOLDER: '例：example@email.com',
        PHONE_PLACEHOLDER: '例：090-1234-5678',
        CONTACT_ARIA: '招待先の連絡先',
        ROLE_SETTING: 'ロール設定',
        SUBMIT: '招待する',
        REQUIRED: '連絡先を入力してください。',
        EMAIL_INVALID: 'メールアドレスの形式を確認してください。',
        PHONE_INVALID: '電話番号の形式を確認してください。',
        SAVE_ERROR: 'メンバーの招待に失敗しました。',
      },
      INVITATIONS: {
        TITLE: '招待状管理',
        DESCRIPTION:
          '送信済み招待リンクです。ユーザーが確認を完了するまで、このアカウントではUSUPPにログインできません。',
        TABLE_ARIA: '招待状一覧',
        COL_VIA: '招待経由',
        COL_ROLE: 'ロール',
        COL_ACTION: '詳細',
        REVOKE_ARIA: '{0}の招待リンクを無効にする',
        SUBMIT: '無効にする',
      },
      REVOKE: {
        TITLE: '招待リンクの無効化',
        DESCRIPTION:
          '以下の招待リンクを無効にします。無効にすると、このリンクからの登録はできなくなります。',
        CONTACT: '招待経由',
        ROLE: 'ロール',
        SUBMIT: '無効にする',
        SAVE_ERROR: '招待リンクの無効化に失敗しました。',
      },
      ROLE_CHANGE: {
        TITLE: '権限変更',
        DESCRIPTION: 'USUPP管理画面の権限を変更します。',
        NAME: '表示名',
        EMAIL: 'メール',
        PHONE: '電話番号',
        ROLE: 'ロール',
        SUBMIT: '変更する',
        SAVE_ERROR: '権限の変更に失敗しました。',
        OWN_ROLE_ERROR: 'ご自身の権限は変更できません。',
      },
    },
    CALENDAR: {
      LOCATION_LIST_TITLE: '本日場所一覧',
      TOTAL_ITEMS: '全{0}件',
      MORE_LOCATIONS: '+{0}場所',
      MONTH_SUFFIX: '{0}月',
      MONTH_DIVIDER: '{0}年{1}月',
      DIALOG: {
        DATE_SELECTION_TITLE: '日付選択',
        SET: '設定',
        YEAR: '{0}年',
        MONTH: '{0}月',
        DAY: '{0}日',
        BOOKING_LIST_TITLE: '{0}の予約詳細',
        LOCATION_COUNT: '{0}場所/{1}名',
        DINNER: '夕食会参加',
        PICK_DATE_TITLE: '予約日を選択',
        PICK_DATE_ARIA: '予約日の選択方法',
        SET_BUTTON: '設定する',
      },
      FILTER_TITLE: '場所で絞り込み',
      SELECT_ALL: '全選択',
      SELECT_ALL_ARIA: '全場所を選択',
      APPLY: '設定',
      LOADING_CALENDAR: 'カレンダーを読み込んでいます',
      FILTERED_COUNT: '{0}件表示中',
      PREV_PERIOD: '前の期間',
      NEXT_PERIOD: '次の期間',
      SWITCH_VIEW: '表示切替',
      MONTH_VIEW: '月間',
      WEEK_VIEW: '週間',
      FILTER: '絞り込み',
      FILTER_LOCATION_ARIA: '場所を絞り込む',
    },
    LOGIN: {
      NO_ACCOUNT: 'アカウントをお持ちでない方はこちら',
      REGISTER: '新規登録',
      TITLE: 'ログイン',
      EMAIL_LABEL: 'メールアドレス',
      EMAIL_PLACEHOLDER: 'メールを入力してください',
      PASSWORD_LABEL: 'パスワード',
      PASSWORD_PLACEHOLDER: 'パスワードを入力してください',
      FORGOT_PASSWORD: 'パスワードを忘れた場合',
      BUTTON: 'ログイン',
      ERROR: 'メールアドレスまたはパスワードが正しくありません。',
      PORTAL_ROLE_MISMATCH:
        'このアカウントには管理画面へのアクセス権限がありません。管理者にお問い合わせください。',
      ACCOUNT_LOCKED: 'このアカウントはロックされています。管理者にお問い合わせください。',
    },
  },
  SELECT: {
    ALL: '全て選択',
  },
  EDITOR: {
    FORMAT_PARAGRAPH: '段落',
    FORMAT_H1: '見出し 1',
    FORMAT_H2: '見出し 2',
    FORMAT_H3: '見出し 3',
    FORMAT_H4: '見出し 4',
    FORMAT_H5: '見出し 5',
    FORMAT_H6: '見出し 6',
    BLOCK_FORMAT: '段落書式',
    FONT_SIZE: 'フォントサイズ',
    ALIGN: {
      LEFT: '左揃え',
      CENTER: '中央揃え',
      RIGHT: '右揃え',
      JUSTIFY: '両端揃え',
    },
    BOLD: '太字',
    ITALIC: '斜体',
    UNDERLINE: '下線',
    TEXT_COLOR: '文字色',
    HIGHLIGHT: '蛍光ペン',
    INSERT_LINK: 'リンクを挿入',
    REMOVE_LINK: 'リンクを削除',
    BULLET_LIST: '箇条書きリスト',
    ORDERED_LIST: '番号付きリスト',
    BLOCKQUOTE: '引用',
    CODE_BLOCK: 'コードブロック',
    INSERT_IMAGE: '画像を挿入',
    INSERT_TABLE: 'テーブルを挿入',
    ADD_ROW: '行を追加',
    DELETE_ROW: '行を削除',
    ADD_COLUMN: '列を追加',
    DELETE_COLUMN: '列を削除',
    DELETE_TABLE: 'テーブルを削除',
    INSERT: '挿入',
    IMAGE_URL: '画像 URL',
    ALT_TEXT: '代替テキスト',
    CAPTION: 'キャプション (オプション)',
    COLOR_AREA_VALUE: '彩度 {0}%、明度 {1}%',
  },
  RESERVATION: {
    COMPLETE: {
      SUCCESS_TITLE: '予約が完了しました',
      SUCCESS_DESC: 'ご予約ありがとうございます。以下より予約内容をご確認ください。',
      SUMMARY_TITLE: '予約申込内容',
      NEEDS_CONFIRMATION_TITLE: '予約が一部完了しました',
      NEEDS_CONFIRMATION_DESC:
        '選択された日程のうち、一部は予約を完了できませんでした。予約状況をご確認のうえ、必要に応じて再度お申し込みください。',
      BOOKING_NUMBER: '予約番号',
      UNSENT: '未送信',
      LOCATION: '場所',
      HELD_DATES: '予約日程',
      FAILED_DATES: '完了できない日程',
      PARTIAL_NOTICE: '一部の日程のみ予約が完了しました',
      NOTICES_ARIA: '予約完了のお知らせ',
      EMAIL_SENT_TITLE: '確認メールを送信しました',
      EMAIL_SENT_DESC: '予約内容はメールまたはマイページからご確認いただけます。',
      ACCOUNT_PROMPT_TITLE: 'アカウント登録のご案内',
      ACCOUNT_PROMPT_DESC: '次回以降の予約をスムーズにするため、アカウント登録がおすすめです。',
      RETRY_BOOKING: 'もう一度予約する',
      RESELECT_DATES: '日程を選び直す',
      RESELECT_LOCATION: '場所を選び直す',
      EDIT_INFORMATION: '入力内容を修正する',
      CONTACT_US: 'お問い合わせ',
      ANOTHER_BOOKING: '別の予約をする',
      VIEW_MYPAGE: '予約内容を確認する',
    },
    SUBMIT_ERROR: {
      TITLE: 'サーバーエラーが発生しました。',
      DESC: 'システムの問題により、予約を完了できませんでした。しばらく時間をおいてから、再度お試しください。',
      MESSAGE: '予約を完了できませんでした。',
      SLOT_TITLE: '定員に達しました',
      SLOT_DESC:
        '申込中にほかの方の予約が確定したため、定員に達しました。お手数ですが、別の日程で再度お申し込みください。',
      SLOT_MESSAGE: '予約を完了できませんでした。',
      DUPLICATE_TITLE: '選択された日程はすでに予約済みです',
      DUPLICATE_MESSAGE: '日程をご確認のうえ、変更が必要な場合は管理者までお問い合わせください。',
      LOCATION_TITLE: '選択された場所は現在ご利用いただけません',
      LOCATION_DESC:
        '選択した場所が利用停止になったため、予約を完了できませんでした。お手数ですが、場所を選択し直してください。',
      LOCATION_MESSAGE: '予約を完了できませんでした。',
      VALIDATION_TITLE: '入力内容にエラーがあります。',
      VALIDATION_DESC:
        '特殊文字や記号が含まれている可能性があります。入力内容をご確認のうえ、再度お試しください。',
      VALIDATION_MESSAGE: '予約を完了できませんでした。',
      ACCOUNT_CREATED: 'アカウントは作成されましたが、予約に失敗しました。再試行してください。',
      GENERAL: '処理に失敗しました。入力内容を確認して再試行してください。',
    },
    RULE: {
      LOAD_ERROR: '予約ルールの取得に失敗しました。時間をおいて再度お試しください。',
    },
    FAILED_REASON: {
      CAPACITY: '満席または受付枠なし',
      DUPLICATE: '重複した予約',
      BOOKING_DEADLINE_PASSED: '受付期限超過',
      ERROR: '予期せぬエラー',
    },
    DATE: {
      MODE_SELECT_ARIA: '予約モード選択',
      RANGE_TITLE: '期間で予約',
      RANGE_HINT: '開始日・終了日を選択',
      MULTIPLE_TITLE: '複数日予約',
      MULTIPLE_HINT: '日付を複数選択',
      LOCATION_LABEL: '場所',
      LABEL: '予約日',
      RESET: 'リセット',
      RESET_ARIA: '選択日をリセット',
      NO_SELECTION: '日程が選択されていません',
      BACK_TO_LOCATION: '場所選択に戻る',
      NEXT_STEP: '次のステップに進む',
      NEXT: '次へ',
      FULL_WARNING: '選択した期間に満席の日が含まれています。日程を変更してください。',
      CLICK_START: '開始日をクリックしてください',
      CLICK_END: '終了日をクリックしてください',
      SELECTED_RANGE: '期間が選択されました',
      CLICK_DATE: '日にちをクリックしてください',
      DAYS_COUNT: '{0}日選択中',
      TAB_RANGE: '期間',
      TAB_MULTIPLE: '複数日程',
      NO_BOOKABLE_DATES: '現在予約可能な日程がありません。',
      DEADLINE_PASSED: '予約受付期限を過ぎた日程が含まれています。日程を再選択してください。',
    },
    CONFIRM: {
      SUMMARY_ARIA: '選択内容',
      ACCOUNT_NOTICE: '次回以降の予約を簡単にするため、任意でアカウントを作成できます。',
      CREATE_ACCOUNT_LABEL: 'アカウントを作成する',
      PASSWORD_LABEL: 'パスワード',
      PASSWORD_HINT: '半角英数字8文字以上で入力してください。',
      PASSWORD_CONFIRM_LABEL: 'パスワード（確認）',
      ACTIONS_ARIA: '予約確認の操作',
      SUBMIT_WITH_ACCOUNT: 'アカウントを登録し、申し込みます',
      SUBMIT_WITHOUT_ACCOUNT: '申し込みます',
      PASSWORD_MISMATCH: 'パスワードが一致しません。',
      PASSWORD_CONFIRM_REQUIRED: '確認用パスワードを入力してください。',
      SMOKING_LABEL: '禁煙・喫煙',
      LUNCH_LABEL: '昼食',
      DINNER_LABEL: '夕食会参加',
      AVAILABLE_DATES_LABEL: '参加可能日',
      REMARKS_LABEL: '連絡事項',
    },
    STEPPER: {
      LOCATION: '場所選択',
      SCHEDULE: '日時選択',
      IDENTITY: '会員連携',
      INFORMATION: '情報入力',
      CONFIRMATION: '内容確認',
      COMPLETION: '完了',
      ARIA: '予約ステップ',
    },
    INFO: {
      NAME_PLACEHOLDER: '例：山田 太郎',
      NAME_KANA_PLACEHOLDER: '例：ヤマダ タロウ',
      EMAIL_PLACEHOLDER: '例：example@email.com',
      PHONE_PLACEHOLDER: '例：090-1234-5678',
      COMPANY_NAME_PLACEHOLDER: '例：株式会社〇〇',
      OFFICE_NAME_PLACEHOLDER: '例：〇〇事業所',
      SECTION_SERVICE: 'サービス情報 （任意項目）',
      SERVICE_TYPE: {
        TOKUYO: '特別養護老人ホーム',
        ROKEN: '介護老人保健施設',
        GH: '認知症対応型共同生活介護（GH）',
        YURYO: '有料老人ホーム',
        KYOTAKU: '居宅介護支援事業所',
        TSUSHO: '通所介護',
        REHA: '通所リハビリ',
        VISITING: '訪問介護',
        VISITING_REHA: '訪問リハビリ',
        VISITING_NURSE: '訪問看護',
        VISITING_NURSE_MED: '（医）訪問看護',
        SHOKIBO: '小規模多機能',
        KANSHOKI: '看護小規模多機能',
        SOGO: '総合支援',
        OTHER: 'その他',
      },
      OTHER_PLACEHOLDER: 'その他の内容を入力してください',
      CAREKARTE_SCOPE: {
        BILLING: '請求業務',
        RECORDING: '記録業務',
        REPORTS: '帳票',
        CAREPLAN: 'ケアプラン作成業務',
        MASTER: 'マスタ関連',
        OTHER: 'その他',
      },
      SECTION_PARTICIPATION: '参加情報',
      PAST_PARTICIPATION_LABEL: '過去参加状況',
      ACCOMMODATION_REQUEST_LABEL: '宿泊手配希望',
      ACCOMMODATION_DETAILS_LABEL: '手配希望',
      TRANSPORTATION_LABEL: '移動手段',
      TRANSPORTATION: {
        SHINKANSEN: '新幹線',
        TRAIN: '在来線（電車）',
        AIRPLANE: '飛行機',
        CAR: '自家用車',
        OTHER: 'その他',
      },
      ACCOMMODATION_TITLE: '宿泊・食事',
      SMOKING_LABEL: '禁煙/喫煙（宿泊時）',
      SMOKING_HINT: '※あくまでも希望のためご希望に添えない場合もございます。',
      LUNCH_LABEL: '昼食',
      LUNCH_HINT: '昼食（お弁当）は弊社にてご用意いたします。不要な場合はその旨ご選択ください。',
      DINNER_LABEL: '夕食会参加',
      DINNER_DATES_LABEL: '参加可能日',
      COMMENTS_TITLE: '連絡事項（任意）',
      COMMENTS_ARIA: '連絡事項',
      BACK_ARIA: '日程選択に戻る',
      NEXT_ARIA: '入力内容を確認する',
      VALIDATION: {
        ACCOMMODATION_DETAILS_REQUIRED:
          '宿泊手配を希望する場合は、「前泊」または「後泊」を1つ以上選択してください。',
        TRANSPORTATION_REQUIRED: '移動手段を1つ以上選択してください。',
        DINNER_DATES_REQUIRED: '夕食会に参加可能な日を1日以上選択してください。',
        COMMENTS_MAX_LENGTH: '連絡事項は300文字以内で入力してください。',
      },
    },
    PAGE: {
      TITLE: 'ケアカルテウサップ 予約',
    },
    STEP: {
      LABEL: 'ステップ{0}: {1}',
    },
    PROFILE: {
      LOADING: '登録済みのプロフィールを読み込んでいます…',
      ERROR: 'プロフィールを読み込めませんでした。予約を続けるには再試行してください。',
      INTRO_FIRST:
        '氏名・氏名（カナ）・メールアドレス（または電話番号）はCKPassの会員情報と連携しています。',
      INTRO_SECOND: '変更する場合は、CKPassより更新してください。',
      SAVING: '保存しています…',
      SAVE_ERROR: '基本情報を保存できませんでした。時間をおいて再度お試しください。',
      LEAVE_DIALOG: {
        TITLE: '基本情報の登録が完了していません',
        MESSAGE:
          '入力内容は保存されていません。\n入力途中の内容は保持されるため、次回このページを開いたときに続けて入力できます。\nこのままページを離れますか？',
        STAY: '入力に戻る',
        LEAVE: 'ページを離れる',
      },
    },
    TITLE: {
      META: 'U-SUPP-U — 予約フォーム',
    },
    DESC: {
      META: 'CAREKARTEコミュニティ「U-SUPP-U」の予約フォームです。',
    },
    ERROR_INPUT: {
      TITLE: '入力エラー',
      MESSAGE: '前のステップを完了してください。',
    },
    DAYS: {
      COUNT: '{0}日間',
    },
    LOCATION: {
      INSTRUCTION: '場所を選択してください',
      LOADING: '場所を読み込んでいます…',
      EMPTY: '現在、選択可能な会場はありません。',
      SELECT_ARIA: '{0}を選択',
      STATUS: {
        AVAILABLE: '予約可能',
      },
      CAPACITY_LABEL: '定員',
      NOTICE_TITLE: '会場を選択してください。',
      NOTICE_HINT: 'ご希望の会場を1つ選択すると、予約可能な日程を確認できます。',
      NO_IMAGE_TITLE: 'NO IMAGE',
      NO_IMAGE_HINT: '画像がありません',
    },
    MEMBER: {
      TITLE: 'Carekarte Passログイン',
      GUIDE:
        '予約のお申し込みにはCKPassアカウントでのログインが必要です。ログインすると、登録済みの情報が次の画面に自動入力されます。',
      EMAIL_LABEL: 'メールアドレス または 電話番号',
      EMAIL_PLACEHOLDER: 'メールアドレス または 電話番号を入力してください',
      PASSWORD_LABEL: 'パスワード',
      PASSWORD_PLACEHOLDER: 'パスワードを入力してください',
      FORGOT_PASSWORD: 'パスワードを忘れた方はこちら',
      LOGIN_BTN: 'ログイン',
      NO_PASS_TITLE: 'CAREKARTE Passをお持ちでない方',
      CREATE_PASS_BTN: 'CAREKARTE Passの新規作成',
      BACK_ARIA: '場所選択に戻る',
    },
  },
  HOME: {
    TITLE: 'U-SUPP-U — ユーザーがユーザーをサポートするCAREKARTEコミュニティ',
    META_DESC:
      'CAREKARTE（ケアカルテ）のユーザーフォーラム「U-SUPP-U（ユーサップユー）」。全国の医療・介護施設のユーザー同士が支え合い、学び合うことで現場全体の力を高めるコミュニティです。',
    HERO: {
      SECTION_ARIA: 'メインビジュアル',
      CARD_ARIA: 'プロジェクト概要',
      MARQUEE_ARIA: '実績データ',
      BRAND_SUB: 'CARE KARTE ウサップ',
      BRAND_TITLE: 'U-SUPP-U',
      HEADLINE_LINE1: '実際にコールセンターで',
      HEADLINE_LINE2: '“ユーザーをサポートする側”',
      HEADLINE_LINE3: 'を体験できる、参加型プロジェクト',
      BTN_ABOUT: 'ウサップとは？',
      BTN_APPLY: '参加申込へ',
      AUDIO_ON: '音声ON',
      AUDIO_OFF: '音声OFF',
      AUDIO_ARIA_MUTE: '音声をミュートにする',
      AUDIO_ARIA_UNMUTE: '音声を再生する',
    },
    USUPP_OVERVIEW: {
      SECTION_ARIA: 'U-SUPP-Uとは？ 概要',
      INTRO_TEXT: '参加することで、CAREKARTEを“使う側”から“伝える側”へ。',
      BTN_MORE: 'もっと見る',
      BRAND_QUESTION: 'とは？',
      PROJECT_HIGHLIGHT: '“ユーザーをサポートする”',
      PROJECT_DESC_LINE1: 'を体験できる、参加型',
      PROJECT_DESC_LINE2: 'プロジェクトです。',
    },
    BENEFIT: {
      BADGE: '人材育成',
      HEADLINE_LINE1: 'CAREKARTEの枠を超え将来、法人の中心となる',
      HEADLINE_LINE2: 'キーマンの育成',
      BTN_APPLY: '参加申込',
      CARD1_SUBTITLE: '外部とのネットワークづくり',
      CARD1_TITLE: 'ユーザー間交流',
      CARD1_DESC_LINE1: 'U-SUPP-Uメンバーへの運用・カスタマイズの相談。',
      CARD1_DESC_LINE2: '事業所運営・経営の知識習得。',
      CARD2_SUBTITLE: '参加者フィードバックによる法人の成長',
      CARD2_TITLE: '施設見学',
      CARD2_DESC_LINE1: 'U-SUPP-U同士の施設見学。',
      CARD2_DESC_LINE2: '知っているからできる深堀した相談・突っ込んだ質問。',
      CARD3_SUBTITLE: '参加者個人の成長',
      CARD3_TITLE: 'コールセンター対応',
      CARD3_DESC_LINE1: 'CAREKARTEの知識習得。',
      CARD3_DESC_LINE2: '他法人の操作方法、運用方法、 カスタマイズアイデア。',
      CARD4_SUBTITLE: 'メーカーとのパイプづくり',
      CARD4_TITLE: '意見交換会',
      CARD4_DESC_LINE1: 'CAREKARTE機能の仕様検討会。',
      CARD4_DESC_LINE2: 'CCJスタッフへの 運用・カスタマイズの相談。',
    },
    PARTICIPATION_FLOW: {
      EYEBROW: '申込後の流れ',
      HEADING: 'ウサップの参加流れチェック！',
      LOCATION_LABEL: '開催場所',
      LOCATION_LINE_1: 'ケアコネクトジャパン',
      LOCATION_LINE_2: '（静岡本社・福岡支店・東京支店・沖縄支店）※',
      TIME_LABEL: '時間',
      TIME_VALUE: '9:00〜18:00 ※',
      COST_LABEL: '費用',
      COST_LINE_1: '静岡までの交通費・宿泊費は',
      COST_LINE_2: 'ケアコネクトジャパンにて負担します',
      REWARD_LABEL: '謝礼',
      REWARD_VALUE: 'あり',
      PHASE_LABEL: 'PHASE {0}',
      STEP_1_TITLE: '参加日程申し込み',
      STEP_2_TITLE: '詳細案内ご連絡',
      STEP_3_TITLE: '契約締結',
      STEP_4_TITLE: '日程ご連絡',
      STEP_5_TITLE: 'ウサップへ参加',
      NOTES_ARIA: '参加に関する注意事項',
      NOTE_FIRST_TIME: '※初回参加の方は、原則、静岡本社での参加のご協力をお願いしております。',
      NOTE_TIME: '※時間調整可能',
    },
    FEEDBACK: {
      HEADING: '参加いただいた方々の声',
      SECTION_ARIA: '参加いただいた方々の声',
      ITEM_1_AUTHOR: '請求とくい様',
      ITEM_1_TAG: '#CAREKARTE活用方法の習得',
      ITEM_1_QUOTE:
        '“請求業務を独自のやり方でやっているところがあった。実際にサポートをしてみて、自分でも調べたりしてみて便利なCAREKARTEの使い方を見つけることができた。”',
      ITEM_2_AUTHOR: 'ケアラク様',
      ITEM_2_TAG: '#CAREKARTE基礎知識の習得',
      ITEM_2_QUOTE:
        '“CAREKARTEを操作していて難しいなと思ったら電話するのではなく、一度調べてみようと思った。請求担当の職員や普段使っている職員にもそれを伝えたい。”',
      ITEM_3_AUTHOR: 'プレミアムタロウ様',
      ITEM_3_TAG: '＃CAREKARTE活用方法の習得',
      ITEM_3_QUOTE:
        '“ケアコネクトジャパンが提供する新しいサービスをいち早く知ることができ、提案や支援も受けて、事業所内で積極活用することができた。”',
      ITEM_4_AUTHOR: 'プレミアムタクヤ様',
      ITEM_4_TAG: '＃交流で得た刺激',
      ITEM_4_QUOTE:
        '“運営で困っている点について、他のユーザーからアドバイスをもらうことができた。”',
      ITEM_5_AUTHOR: 'プレミアムケア様',
      ITEM_5_TAG: '＃CAREKARTE活用方法の習得',
      ITEM_5_QUOTE:
        '“他施設の状況を知る事ができるいい機会になった。自社のCAREKARTEがフルカスタマイズなのでボタン配置なども違い戸惑いがあった。色々見れる点では参考になった。”',
      ITEM_6_AUTHOR: 'ディーミナト様',
      ITEM_6_TAG: '＃CAREKARTE基礎知識の習得',
      ITEM_6_QUOTE:
        '“現在はデイに携わっているがサポートをして居宅など他サービスにも触れられたので今後も活用していきたい。”',
      ITEM_7_AUTHOR: '請求はると様',
      ITEM_7_TAG: '＃CAREKARTE基礎知識の習得',
      ITEM_7_QUOTE:
        '“普段の業務以外の請求について知れたことがよかった。個人請求等、普段業務の対応もあり、スムーズに回答できたのが良かった。”',
      ITEM_8_AUTHOR: 'ケアマネまい様',
      ITEM_8_TAG: '＃交流で得た刺激',
      ITEM_8_QUOTE:
        '“他法人の方とのコミュニケーションやコールセンターでの対応然り、とても勉強になり、有意義だった。”',
      ITEM_9_AUTHOR: '加算しゅん様',
      ITEM_9_TAG: '＃交流で得た刺激',
      ITEM_9_QUOTE:
        '“自社で取得していない加算（取りたい加算）について、他法人の参加者から取得のアドバイスをもらうことができた。”',
      ITEM_10_AUTHOR: '請求すすみ様',
      ITEM_10_TAG: '＃交流で得た刺激',
      ITEM_10_QUOTE:
        '“他施設の請求担当者の力量がわかって驚いた（相談員やケアマネにも請求担当者がいる点）”',
      ITEM_11_AUTHOR: '静岡めい様',
      ITEM_11_TAG: '＃CAREKARTE基礎知識の習得',
      ITEM_11_QUOTE: '“使っていない機能を聞かれたこともあったが色々調べて機能の知識が増えた”',
      ITEM_12_AUTHOR: 'ディーケント様',
      ITEM_12_TAG: '＃CAREKARTE基礎知識の習得',
      ITEM_12_QUOTE:
        '“普段はデイしか触っていないが、小規模や居宅の問題にも触れられて良かったと思う。”',
      ITEM_13_AUTHOR: 'アイシティケア様',
      ITEM_13_TAG: '＃交流で得た刺激',
      ITEM_13_QUOTE:
        '“ケアコネクトジャパンの仕事にはムダがないと思った。Teamsなどで連絡し、動きが無駄がなく見習いたいと思った。”',
      ITEM_14_AUTHOR: '駿河アイ様',
      ITEM_14_TAG: '＃CAREKARTE基礎知識の習得',
      ITEM_14_QUOTE:
        '“ナレッジを見て解決することが多く、直接問い合わせすることが減った。しっかり調べてみようと思った。”',
      ITEM_15_AUTHOR: 'ソウダン楽様',
      ITEM_15_TAG: '＃交流で得た刺激',
      ITEM_15_QUOTE:
        '“全国のユーザー様とやり取りする中で、どの相談員さんも同じ悩みを持っていらっしゃるんだと共有できた。”',
      ITEM_16_AUTHOR: 'つなぐゆみ様',
      ITEM_16_TAG: '＃交流で得た刺激',
      ITEM_16_QUOTE: '“ケアコネクトジャパンでは紙を使っていなくてびっくりした。”',
      ITEM_17_AUTHOR: '福岡はるこ様',
      ITEM_17_TAG: '＃交流で得た刺激',
      ITEM_17_QUOTE: '“自社でも担当者を作って育成していく必要性を感じた。”',
      ITEM_18_AUTHOR: '一二三太郎様',
      ITEM_18_TAG: '＃交流で得た刺激',
      ITEM_18_QUOTE: '“休憩時間他のユーザーの方々とも会話でき楽しかった。”',
    },
    ANNOUNCEMENT: {
      SECTION_ARIA: 'お知らせ一覧',
      HEADING: 'お知らせ一覧',
      LOGO_ALT: 'U-SUPP-U ユーザーサポートユーザー',
    },
  },
  CLIENT_LOGIN: {
    TITLE: 'ログイン',
    SUBTITLE: '登録済みの情報を予約に利用します。',
    EMAIL_LABEL: 'メールアドレス',
    PASSWORD_LABEL: 'パスワード',
    ERROR_MESSAGE: 'ログインできませんでした。入力内容を確認してください。',
    BUTTON_LOGGING_IN: 'ログイン中…',
    BUTTON_LOGIN: 'ログイン',
  },
  INQUIRY: {
    SUBTITLE: 'ご質問やご不明点がございましたら、以下のフォームよりお気軽にお問い合わせください。',
    INQUIRY_TYPE: 'お問合せ種別',
    RESERVATION: '予約に関して連絡',
    OTHER: 'その他',
    RESERVATION_NUMBER: '予約番号',
    CONTENT: 'お問合せ内容',
    NAME_PLACEHOLDER: '例：草地 太郎',
    EMAIL_PLACEHOLDER: '例：example@email.com',
    PHONE_PLACEHOLDER: '例：090-1234-5678',
    RESERVATION_NUMBER_PLACEHOLDER: '例：FSZ123abc7',
    CONTENT_PLACEHOLDER: '例：予約日を変更したいのですが、変更可能でしょうか。',
    SUBMIT: '送信する',
    SUCCESS_TITLE: 'お問い合わせを送信しました。',
    SUCCESS_MESSAGE: 'お問い合わせを受け付けました。',
    ERROR_TITLE: '送信エラー',
    ERROR_MESSAGE: 'お問い合わせの送信に失敗しました。時間をおいて再度お試しください。',
    FAQ_TITLE: 'よくあるご質問',
    FAQ_BODY: 'お問い合わせ前に解決できる内容が見つかるかもしれません。',
    FAQ_ACTION: 'FAQを見る',
    CONTACT_TITLE: 'お問い合わせ先',
    CONTACT_BODY: 'お急ぎの場合は、\nお電話でもお問い合わせいただけます。',
    PHONE_NUMBER: '0800-200-0873',
    BUSINESS_HOURS_LABEL: '受付時間',
    BUSINESS_HOURS: '9:00〜18:00',
    BUSINESS_HOURS_NOTE: '（土日祝・年末年始を除く）',
    VALIDATION: {
      CONTENT_MAX_LENGTH: 'お問い合わせ内容は300文字以内で入力してください。',
    },
  },
  TICKET: {
    BOOKING_DATE_LABEL: '予約日 / BOOKING DATE',
    NAME_LABEL: '予約者 / NAME',
    BOOKING_NO_LABEL: '予約番号 / BOOKING NO.',
    BOOKING_NO_COPIED: '予約番号をコピーしました。',
    SMOKING_ALLOWED: '喫煙可',
    SMOKING_NOT_ALLOWED: '禁煙',
    ACCOMMODATION: '宿泊',
    DINNER: '夕食会参加',
    CANCEL: {
      BUTTON_LABEL: 'この予約を取り消す',
      DEADLINE_HINT: '※この予約は　{0}まで取り消せる',
      CONFIRM_TITLE: '確認',
      CONFIRM_MESSAGE: '取り消すと、この予約は元に戻せません。',
      CONFIRM_ACTION: '取り消す',
    },
  },
  NEWS: {
    TITLE: 'お知らせ一覧',
    BACK_TO_LIST: 'お知らせ一覧へ戻る',
    LOADING: '読み込み中...',
    NOT_FOUND: '該当のお知らせが見つかりません。',
    EMPTY: '現在お知らせはありません。',
    SHARE: 'このお知らせを共有する',
    LINK_COPIED: 'リンクをコピーしました。',
  },
  BOOKING_HISTORY: {
    TITLE: '予約履歴',
    TABS: {
      ACTIVE: '予約済み',
      PAST: '過去の予約',
    },
    EMPTY: {
      ACTIVE: '現在、予約済みの予約はありません。',
      PAST: '過去の予約履歴はありません。',
    },
    CANCEL_TOAST_MESSAGE: '予約を取り消しました。',
    CANCEL_ERROR_MESSAGE: '予約のキャンセルに失敗しました。時間をおいて再度お試しください。',
    RULE_LOAD_ERROR: '予約ルールの取得に失敗したため、キャンセル操作を制限しています。',
    ERROR: {
      TITLE: 'キャンセル不可',
      CANCELLATION_DEADLINE_PASSED: 'キャンセル期限を過ぎているため、キャンセルできません。',
      NOT_FOUND: '予約が見つかりません。すでにキャンセルされているか、削除された可能性があります。',
      PROCESSING_CANNOT_CANCEL: '予約を処理中のため、取り消しできません。',
      PAST_CANNOT_CANCEL: '過去の予約は取り消しできません。',
      ALREADY_CANCELLED: 'この予約はすでに取り消し済みです。',
    },
  },
  ABOUT_US: {
    PAGE_TITLE: 'U-SUPP-U（ウサップ）とは',
    DOCUMENT_TITLE: 'U-SUPP-U（ウサップ）とは | CAREKARTE',
    META_DESCRIPTION:
      'U-SUPP-U（ウサップ）の概要、実施拠点、実績、お問い合わせ情報をご案内します。',
    HERO: {
      TITLE_BRAND: 'U-SUPP-U',
      TITLE_READING: '（ウサップ）',
      DESCRIPTION:
        'は、実際にコールセンターで"ユーザーをサポートする側"を体験できる、参加型プロジェクトです。',
      IMAGE_ALT: 'コールセンターでサポート業務を行うスタッフ',
    },
    LEAD: {
      ARIA: 'プロジェクトの背景',
      TEXT: '当初は制度改定の時期限定で始まりましたが、参加された皆さまからの声を多数いただき、ご好評につき現在も継続しています。',
    },
    BENEFITS: {
      SECTION_TITLE: '参加のメリット',
      CARD_LEAD: '参加することで、CAREKARTEを"使う側"から"伝える側"へ。',
      CARD_BODY:
        '人に教える経験を通じて理解が深まり、職員の育成やチームの底上げにもつながります。また、意識の高いユーザーとの交流によって、成功事例や工夫をリアルに吸収できる貴重な機会にもなっています。',
    },
    LOCATIONS: {
      SECTION_TITLE: '実施拠点',
      CARD_TEXT:
        '福岡支店の改装により、福岡でもウサップの実施が可能になりました。東京支店、京都支店も開所予定です。（初回は静岡でのご参加をお願いしております）',
      MAP_ALT: 'ウサップ実施拠点マップ（静岡・東京・京都・福岡）',
    },
    METRICS: {
      SECTION_TITLE: '参加実績',
      CORPORATIONS: {
        TITLE: '参加法人数',
        UNIT: '累計法人',
        YEAR_2024: '2024年',
        YEAR_2025: '2025年',
      },
      PARTICIPANTS: {
        TITLE: '参加者数',
        UNIT: '累計名',
        YEAR_2024: '2024年',
        YEAR_2025: '2025年',
      },
      CASES: {
        TITLE: '対応総件数',
        UNIT: '累計件',
        YEAR_2024: '2024年',
        YEAR_2025: '2025年',
      },
      SUPPORT_RATE: {
        TITLE: 'サポート割合',
        PREFIX: '約',
        UNIT: '%',
        NOTE_LINE1: 'サポート全体の',
        NOTE_LINE2: 'ウサップにて対応',
      },
      FOOTNOTE: '※2025年12月時点のデータです',
    },
    HOURS: {
      SECTION_TITLE: '営業時間',
      WEEKDAY_LABEL: '平日',
      WEEKDAY_HOURS: '9:00 - 18:00',
      HOLIDAY_LABEL: '土日・祝日',
      HOLIDAY_STATUS: '定休日（Closed）',
    },
    CONTACT: {
      SECTION_TITLE: 'お問い合わせ',
      PHONE_NUMBER: '0800-200-0873',
      PHONE_HOURS: '受付時間：平日 9:00 - 18:00',
      WEBSITE_URL: 'https://www.carekarte.jp/u-supp-u/',
      WEBSITE_LABEL: 'ウサップ公式サイト（詳細情報・申し込み）',
    },
    CTA: {
      ARIA: 'ホームへ戻る',
      MESSAGE: 'ぜひ本プロジェクトをご活用いただき、職員育成や組織強化の一助としてご検討ください。',
      BACK_HOME: 'ホームに戻る',
    },
  },
};
